import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { LEADS_TABLE_COLUMN_IDS } from 'components/elements/LeadsTable/constants';
import ProjectNotesAPI from 'services/API/ProjectNotesAPI';
import type { PaginatedProject } from 'types';

type LeadTableNote = {
  note: string;
  first_name: string;
  is_mine: boolean;
};

export function useLeadsTableNotes(
  items: PaginatedProject[],
  isTableLoading: boolean,
  visibleColumnOrder: string[],
) {
  const { entityIds, keySignature } = useMemo(() => {
    const ids = new Set<string>();
    items.forEach((item) => {
      const key =
        item.id !== undefined && item.id !== null ? String(item.id) : item.document_id;
      if (key) {
        ids.add(key);
      }
    });
    const newEntityIds = Array.from(ids).sort();
    const newKeySignature = newEntityIds.join(',');

    return { entityIds: newEntityIds, keySignature: newKeySignature };
  }, [items]);

  const notesEnabled =
    !isTableLoading &&
    items.length > 0 &&
    visibleColumnOrder.includes(LEADS_TABLE_COLUMN_IDS.MY_NOTES);

  const { data, isLoading } = useQuery(
    ['leadsTableNotesBatch', keySignature],
    () => ProjectNotesAPI.fetchLeadsTableNotesBatch(entityIds),
    { enabled: notesEnabled, refetchOnWindowFocus: false },
  );

  const notesByEntityId: Record<string, LeadTableNote> = (data ?? {}) as Record<
    string,
    LeadTableNote
  >;

  return {
    notesByEntityId,
    isNotesLoading: notesEnabled && isLoading,
  };
}
